import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";

export function useOAuthOperation() {
  const location = useLocation();
  const { getAuthGeneration } = useAuth();
  const current = useRef<{ active: boolean } | null>(null);
  useLayoutEffect(() => {
    const scope = { active: true };
    current.current = scope;
    return () => { scope.active = false; };
  }, [location.key, location.pathname, location.search, location.hash]);
  return () => {
    const scope = current.current;
    const generation = getAuthGeneration();
    return () => !!scope?.active && scope === current.current && generation === getAuthGeneration();
  };
}
